<template>
  <div class="card">
    <div class="card-header">
      Areas
    </div>
    <div class="p-6">
      <radio-group
        v-model="form.area_policy"
        :options="[
          { label: `Don't Apply Area Rules`, value: '' },
          { label: `Only Run in These Areas`, value: 'inside' },
          { label: `Don't Run  in These Areas`, value: 'outside' }
        ]" />
      <Collapse :active="form.area_policy !== ''">
        <AreaToggle class="mt-4" :parent="form" @toggle="methods.toggleArea" />
      </Collapse>
    </div>
  </div>
</template>

<script>
import AreaToggle from '@/components/AreaToggle'

export default {
  name: 'AreaCard',

  components: {
    AreaToggle
  },

  props: {
    form: {
      type: Object,
      required: true
    },
    
    methods: {
      type: Object,
      required: true
    }
  }
}
</script>